import consumer from "./consumer";

export default (campaignId, received) =>
  consumer.subscriptions.create(
    { channel: "CampaignChannel", id: campaignId },
    { received }
  );
